import { selectChannel } from '@/modules/Channels';
import { useAppDispatch, useAppState } from '@/store';
import { useCallback } from 'react';
import { uploadBrandDetails } from '../feature';
import { selectError, selectIsLoading } from '../feature/selectors';

export const useUpdateShowBrand = () => {
  const isLoading = useAppState(selectIsLoading);
  const channel = useAppState(selectChannel);
  const error = useAppState(selectError);

  const dispatch = useAppDispatch();

  const updateBrandCallback = useCallback(
    async (brandId: string, isActive: boolean) => {
      if (!channel) return;
      await dispatch(
        uploadBrandDetails({
          id: brandId,
          channelId: channel.id,
          showOnBrandPage: isActive,
        }),
      );
    },
    [dispatch, channel],
  );

  return {
    updateBrandDisplay: updateBrandCallback,
    isLoading,
    error,
  };
};
